import styled from "styled-components";
import { colors } from "../../colors/color";


export const StyledToolTip = styled.span`
    position: absolute;
    align-items: center;
    background: white;
    border: 1px solid ${colors.tooltip.border};
    border-radius: 4px;
    bottom: -30px;
    color: ${colors.tooltip.text};
    display: flex;
    font-family: "Noto Sans", sans-serif;
    font-size: 16px;
    font-weight: 400;
    height: 32px;
    left: 36px;
    line-height: 1;
    padding: 1px 8px;
    z-index: 1000;
`;